module.exports = __webpack_public_path__ + "static/media/houston-medical-imaging-logo.b1ae29a5.png";